module.exports = __webpack_public_path__ + "static/media/cupra.7b3f3bcc.png";